import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom"

import { Collection } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";

import "./GalleryPage.css";
import { ImageCardName } from "./../components/ImageCard";
import { ImageUploader } from "./../components/ImageUploader";
import { S3Provider } from "./../providers/S3Provider"

import { Grid } from 'react-loader-spinner'
import InfiniteScroll from 'react-infinite-scroll-component';

type RouteParams = {
  folder: string
}

function GalleryPage() {
  const [imageKeys, setImageKeys] = useState<string[]>([]);
  const [thumbnails, setThumbnails] = useState<string[]>([]);
  const [images, setImages] = useState<string[]>([]);

  const [thumbnailsShown, setThumbnailsShown] = useState<string[]>([]);
  const [imagesShown, setImagesShown] = useState<string[]>([]);
  const [stillHasMore, setStillHasMore] = useState(true);
  //const [folder, setFolder] = useState<string>("Test-Event-ABC-1/")
  const param = useParams<RouteParams>();
  const folder = `${param.folder}/`
  

  const fetchImages = async () => {
    if (folder != undefined) setImageKeys((await S3Provider.listObjectsInFolder(folder)))
  };

  useEffect(() => {
    fetchImages();
  }, [folder]);

  useEffect(() => {
    (async () => {
      setImages(imageKeys.map(S3Provider.getObjSrc));
      setThumbnails(imageKeys.map(S3Provider.getObjThumbnailSrc));

      setImagesShown(imageKeys.map(S3Provider.getObjSrc).slice(0,15));
      setThumbnailsShown(imageKeys.map(S3Provider.getObjThumbnailSrc).slice(0,15));
      if (imageKeys.length <= 15) {
        setStillHasMore(false);
      } else {
        setStillHasMore(true);
      }
    })().catch(console.error);
  }, [imageKeys]);


  const fetchMoreData = () => {
    if (imageKeys.length === 0) return;
    const FETCH_NUM = 10;
    const localImages = [...images];
    const localThumbnails = [...thumbnails];

    setImagesShown([...imagesShown, ...localImages.splice(imagesShown.length, FETCH_NUM)]);
    setThumbnailsShown([...thumbnailsShown, ...localThumbnails.splice(thumbnailsShown.length, FETCH_NUM)]);
    if (imagesShown.length >= images.length) {
      setStillHasMore(false);
    }
  };

  if (folder == undefined) return <> </>
  return (
    <>
      <Link to={"/"}>&lt; Back to event list</Link>
      <h1>Event Gallery</h1>
      <ImageUploader setImageKeys={setImageKeys} folder={folder} clearCallback={fetchImages} />

      <InfiniteScroll
        dataLength={imagesShown.length}
        next={fetchMoreData}
        hasMore={stillHasMore}
        loader={<h4 style={{marginLeft: '20px'}}>Loading...</h4>}
      >
      {images.length === 0 ?

        <Grid
          height="50"
          width="50"
          ariaLabel="grid-loading"
          radius="12.5"
          wrapperStyle={{ padding: '20px', margin: '0 auto' }}
          wrapperClass=""
          visible={true}
          color='#772ddb'
        />
        :
        <Collection
          items={imagesShown}
          type="grid"
          padding="20px"
          boxShadow="0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)"
          maxWidth="1100px"
          margin="0 auto"
          justifyContent="center"
          templateColumns={{
            base: "minmax(0, 500px)",
            medium: "repeat(2, minmax(0, 1fr))",
            large: "repeat(3, minmax(0, 1fr))"
          }}
          gap="small"
        >
          {(item, index) => (
            <ImageCardName
              key={index}
              imageKeys={imageKeys.map(e => e.substring(folder.length))}
              thumbnails={thumbnails}
              imgSrc={item}
              index={index}
            />
          )}
        </Collection>
        }
      </InfiniteScroll>
    </>
  );
}
export default GalleryPage;